import { ConfirmationModal } from 'seagull';
import { useEventReporter, useOverlayContext, useStoreActions } from "../contexts";
import { ServerError } from "../infra/ErrorResponse";
import { handlePromise, handleRequest } from "../infra/utils";
import { InvoiceStatus } from "../models/invoice";
import { jsx as _jsx } from "react/jsx-runtime";
const markAsPaidLoader = 'markAsPaid';
export function shouldShowMarkAsPaid(status, isVendor) {
  if (!isVendor) {
    return false;
  }
  return [InvoiceStatus.PaymentStopped, InvoiceStatus.PaymentFailed, InvoiceStatus.Pending, InvoiceStatus.RequiresPaymentApproval, InvoiceStatus.PaymentDisputed, InvoiceStatus.PaymentActionRequired].includes(status);
}
export async function doMarkAsPaid(_ref) {
  let {
    invoiceId,
    markAsPaidExternally,
    logBI,
    startLoader,
    stopLoader,
    showErrorToast,
    reportToHeap,
    dismissModal,
    onSuccess
  } = _ref;
  logBI(10580);
  reportToHeap('Invoice', 'click', 'mark-as-paid');
  startLoader(markAsPaidLoader);
  const result = await handleRequest(markAsPaidExternally(invoiceId));
  if (result.success) {
    onSuccess && (await handlePromise(onSuccess()));
    stopLoader(markAsPaidLoader);
    dismissModal(true);
  } else {
    stopLoader(markAsPaidLoader);
    const errorMessage = result.error.hasServerError(ServerError.IncorrectStatusForPaidExternally) ? 'Invoice cannot be marked as paid. Please refresh the page and try again.' // We assume we got here because of stale data.
    : 'Unable to mark the invoice as paid, please try again';
    showErrorToast(errorMessage);
    dismissModal(false);
  }
}
export function usePaidExternally() {
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    startLoader,
    stopLoader,
    showErrorToast,
    showModal
  } = useOverlayContext();
  const {
    reportToHeap
  } = useEventReporter();
  function markAsPaid(invoice, onSuccess) {
    return showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          title: "Mark this invoice as paid externally",
          content: "Marking this invoice as paid externally will stop Anchor from processing payment on this invoice.",
          "data-testid": "mark-as-paid-confirmation-modal",
          primaryButtonLabel: "Mark as paid externally",
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: () => dismissModal(false),
          onCloseButtonClick: () => dismissModal(false),
          onPrimaryButtonClick: () => doMarkAsPaid({
            invoiceId: invoice.id,
            markAsPaidExternally: api.invoice.markAsPaidExternally,
            logBI,
            startLoader,
            stopLoader,
            showErrorToast,
            reportToHeap,
            dismissModal,
            onSuccess
          })
        });
      }
    });
  }
  return {
    markAsPaid,
    shouldShowMarkAsPaid
  };
}